import { defineStore } from 'pinia';
import type { TArticle } from '~~/types/local_types';

type TStoreState = {
  page?: undefined | TArticle;
};

const usePageStore = defineStore('page', {
  state: (): TStoreState => {
    return {
      page: undefined,
    };
  },
  actions: {
    setCurrentPage(data?: undefined | TArticle) {
      this.$state.page = data;
    },
  },
  getters: {
    currentPage: (state) => state.page,
    isArticle: (state): boolean =>
      !!(state.page && Object.prototype.hasOwnProperty.call(state.page, 'articleType')),
    hasChatContent: (state): boolean =>
      !!state.page?.content?.some((c) => c.collection === 'content_chats'),
  },
});

export default usePageStore;
